// resources/js/app.js
import "../css/app.css";
import "./bootstrap";
import "./jquery-global";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createApp, h } from "vue";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import "daisyui/dist/full.css";
import "./Assets/main.css";
import { Icon } from "@iconify/vue";
// O editor Quill não é registrado aqui: os componentes que o usam (QuillEditor, InputQuill e
// InputQuillEditor) o importam, e assim ele só é baixado nas telas com editor.

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });
        app.component("Icon", Icon);
        app.use(plugin).use(ZiggyVue).mount(el);

        return app;
    },
    progress: {
        color: "#4B5563",
    },
});
